export default __webpack_public_path__ + "static/media/brand.d0fc4a25.png";